export default __webpack_public_path__ + "static/media/facadelow.3f81962e.jpg";